module.exports = __webpack_public_path__ + "static/media/chat02.cf966a29.gif";